var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","column":"","fill-height":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-progress-circular',{attrs:{"rotate":360,"size":100,"width":15,"indeterminate":true,"color":"primary"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }